import defaultState from './state'

const setHospitalization = (state, newHospitalization) => {
  const currentHospitalization = { ...newHospitalization }
  Object.assign(state, { currentHospitalization })
}

const resetState = state => {
  Object.assign(state, {
    ...defaultState()
  })
}

export default {
  setHospitalization,
  resetState
}
